export enum IconColour {
  Black = 'black',
  White = 'white',
}
